import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerHomeDetailsApiCall, triggerPanSaveApiCallSuccess } from 'redux/actions';
import { TRIGGER_PAN_SAVE_API } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import { CleverTapEvent, CleverTapEventNames, getAppInfo, nativeHandler } from 'utils';

function* triggerPanSaveApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const sendData = {
		...data,
		latitude: getAppInfo()?.latitude || '',
		longitude: getAppInfo()?.longitude || '',
	};
	const CALL_HOME_DETAILS = data['callHomeDetails'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.PAN_SAVE,
		data: { ...sendData },
		method: 'POST',
		options: {
			defaultLoader: !stopLoader,
			dontRemoveLoader: true,
		},
		loaderDetails: {
			first_message: CALL_HOME_DETAILS ? 'calculating your' : 'loading',
			start_index: 0,
			range: CALL_HOME_DETAILS ? 11 : 7,
			second_message: CALL_HOME_DETAILS ? 'credit limit' : 'please wait',
		},
	});
	if (api && (api.data.statusCode === '200' || api.data.statusCode === '400')) {
		const apiData = api.data.data;
		if (api.data.statusCode === '200') {
			CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.BANK_VERIFIED);
		}
		callback && callback(api.data);
		yield put(triggerPanSaveApiCallSuccess(apiData));
		if (CALL_HOME_DETAILS) {
			yield put(
				triggerHomeDetailsApiCall({
					fireAccountCreationEvent: true,
					isReceivedLimitAccountOnboarding: store.getState().homeDetails?.accountStatus === 'PREACTIVE',
				}),
			);
		} else {
			nativeHandler.removeLoader();
		}
	} else {
		data.disableButton && data.disableButton();
		nativeHandler.removeLoader();
	}
}

export default function* triggerPanSaveApiCallSaga() {
	yield takeEvery(TRIGGER_PAN_SAVE_API, triggerPanSaveApiCall);
}
